import data_enemies from '../data/enemies'
var all_letters = ['A','Z','E','R','T','Y','U','I','O','P','Q','S','D','F','G','H','J','K','L','M','W','X','C','V','B','N']
// var all_letters = ['Z','R','T','Y','P','Q','S','D','F','G','H','J','K','L','M','W','X','C','V','B','N']

const Utils = {

	remove_accents: function(str) {
		str = str.replace(/[ÀÁÂÃÄÅ]/g,"A")
		str = str.replace(/[àáâãäå]/g,"a")
		str = str.replace(/[ÈÉÊË]/g,"E")
		return str.replace(/[^a-z0-9]/gi,'')
	},


	init: function() {
		all_letters = ['A','Z','E','R','T','Y','U','I','O','P','Q','S','D','F','G','H','J','K','L','M','W','X','C','V','B','N']
	},


	generate_player_letters: function(data, store) {
		var vowels = _.sampleSize(['A','E','U','I','O'], 4)
		for (var i in vowels) { Utils.remove_from_all_letters(vowels[i]) }
		
		var consonants = _.sampleSize(all_letters, 5)
		for (var i in consonants) { Utils.remove_from_all_letters(consonants[i]) }

		var letters = _.clone(_.union(consonants, vowels))
		return _.shuffle(letters)
	},


	generate_enemy: function(data, store) {
		var enemy = {}

		var length = { min: 3, max: 4 }
		if (data.level == 2) length = { min: 4, max: 5 }
		if (data.level == 3) length = { min: 6, max: 7 }
		if (data.level == 4) length = { min: 8, max: 9 }
		
		var name = _.clone(_.sample(_.filter(data_enemies, function(str) { return str.length >= length.min && str.length <= length.max })))
		enemy = { word: name, letters: [] }

		for (var i in name) {
			enemy.letters.push({ id: _.uniqueId('enemy-letter-'), letter: name[i].toUpperCase(), active: true })
		}

		return enemy;
	},


	generate_loot: function(data, store) {
		var loot = {}
		var types = { letter: 50, heal: 30, 'life-up': 20 }

		var type = false
		var n = _.random(1, 100)
		var current = 0
		for (var i in types) {
			current += types[i]
			if (n <= current) {
				type = i
				break
			}
		}

		loot.type = type

		if (type == 'heal') {
			var value = _.random(3, 9)
			if (data.level == 2) value = _.random(3, 9)
			if (data.level == 3) value = _.random(6, 9)
			if (data.level == 4) value = _.random(9, 12)
			
			loot.name = "Soin"
			loot.value = value
		}
		else if (type == 'letter') {
			loot.name = "Lettre"
			loot.value = _.sample(all_letters)
		}
		else if (type == 'life-up') {
			var value = _.random(1, 2)
			if (data.level == 2) value = _.random(1, 3)
			if (data.level == 3) value = _.random(2, 4)

			loot.name = "Vie max."
			loot.value = value
		}
		
		return loot
	},


	remove_from_all_letters: function(letter) {
		_.pull(all_letters, letter)
	}




}

export default Utils 


// WEBPACK FOOTER //
// ./src/core/Utils.js